import styled from "styled-components";

export const MobileGrid = styled.div<{ columns?: number }>`
    display: grid;
    grid-template-columns: repeat(${({ columns }) => columns || 2}, 1fr);
    gap: 12px;
    padding: 0 4px;
`;

export const MobileCardWrapper = styled.div`
    cursor: pointer;
    border-radius: var(--video-card-border-radius, 8px);
    overflow: hidden;
    background: ${({ theme }) => theme.mobileCardBg};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const ThumbnailWrapper = styled.div`
    line-height: 0;
    aspect-ratio: 16 / 9;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const CardTitle = styled.div`
    font-weight: 700;
    font-size: 14px;
    padding: 8px 8px 10px;
    margin: 0;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-word;
    color: ${({ theme }) => theme.mobileCardTitleColor};
`;
